import { useAppSelector, useAppTranslation } from 'app/hooks';
import Typo from 'consts/typography';
import React from 'react';
import { platformStates } from 'redux/platformSlice';

interface MyBetsTabProps {
  currentTab: number;
  changeTab: (tab: number) => void;
}

const MyBetsTab: React.FunctionComponent<MyBetsTabProps> = ({ currentTab, changeTab }) => {
  const platform = useAppSelector(platformStates);
  const t = useAppTranslation();

  const textButtons = [
    {
      value: 1,
      label: t('myBetTab.active'),
    },
    {
      value: 2,
      label: t('myBetTab.settled'),
    },
  ];

  const onChangeActiveTab = (value: number) => {
    changeTab(value);
  };
  return (
    <div className="w-full flex flex-row items-center justify-between my-bets-tab">
      {textButtons.map((x) => (
        <button
          key={`my-bet-tab-${x.value}`}
          className={`cursor-pointer ${platform.isDesktop || platform.isLargeDesktop ? Typo.p5 : Typo.p7
            } ${currentTab === x.value ? 'active' : ''}`}
          onClick={() => onChangeActiveTab(x.value)}
        >
          {x.label}
        </button>
      ))}
    </div>
  );
};

export default MyBetsTab;
